import type { Module } from "@webmotors/ioc";
import { LoggerModule } from "../logger";
import { SessionStorageService } from "./session-storage.service";

export const SessionStorageModule: Module = {
  name: "SessionStorageModule",
  modules: [LoggerModule],
  providers: [SessionStorageService],
};
